const EN = {
  Refreshing: "Refreshing",
  Refresh: "Refresh",
  Thai: "Thai",
  English: "English",
  Euro: "Euro",
  Hongkong: "Hongkong",
  Malay: "Malay",
  "Sign Out": "Sign Out",
  Change: "Change",
  to: "to",
  "Account Info": "Account Info",
  "Odds type": "Odds type",
  Languages: "Languages",
  Results: "Results",
  Back: "Back",
  Draw: "Draw",
  Refund: "Refund",
  win: "Win",
  lose: "Lose",
  "half win": "Half Win",
  "half lose": "Half Lose",
  "half_win": "Half Win",
  "half_lose": "Half Lose",
  draw: "Draw",
  refund: "Refund",
  running: "Running",
  waiting: "Waiting",
  cancelled: "Cancelled",
  "All Announcement": "All Announcement",
  "List of Sports": "List of Sports",
  Football: "Football",
  Basketball: "Basketball",
  "Coming Soon": "Coming Soon",
  Cricket: "Cricket",
  Volleyball: "Volleyball",
  Boxing: "Boxing",
  "Thai boxing": "Thai boxing",
  Cockfight: "Cockfight",
  Bullfight: "Bullfight",
  Combo: "Combo",
  "Table Tennis": "Table Tennis",
  Tennis: "Tennis",
  "All Result": "All Result",
  Rules: "Rules",
  "Rules and regulations": "Rules and regulations",
  Statement: "Statement",
  "Date time": "Date time",
  Type: "Type",
  "Date & Time": "Date & Time",
  Time: "Time",
  Event: "Event",
  "Full Time": "Full Time",
  "First Half": "First Half",
  "Live / Today": "Live / Today",
  Live: "Live",
  Today: "Today",
  Early: "Early",
  ALL: "ALL",
  Leagues: "Leagues",
  League: "League",
  Search: "Search",
  "Select / Cancel all": "Select / Cancel all",
  selected: "selected",
  "League is not found": "League is not found",
  Confirm: "Confirm",
  Cancel: "Cancel",
  "No market": "No market",
  "No competition": "No competition",
  "No statement on this date range": "No statement on this date range",
  Competition: "Competition",
  "Half-time": "Half-time",
  "Second Half": "Second Half",
  Q1: "Q1",
  Q2: "Q2",
  Q3: "Q3",
  Q4: "Q4",
  OT: "OT",
  "Match Result": "Match Result",
  "Set 1": "Set 1",
  "Set 2": "Set 2",
  "Set 3": "Set 3",
  "Set 4": "Set 4",
  "Set 5": "Set 5",
  "Total Points": "Total Points",
  "Game 1": "Game 1",
  "Game 2": "Game 2",
  "Game 3": "Game 3",
  "Total Games": "Total Games",
  "Kickoff Time": "Kickoff Time",
  Match: "Match",
  Final: "Final",
  "Total Sets": "Total Sets",
  "Full-time": "Full-time",
  Date: "Date",
  "No.": "No.",
  Message: "Message",
  "Bet amount": "Bet amount",
  "Win / Lose": "Win / Lose",
  Commission: "Commission",
  Total: "Total",
  "Place bet success": "Place bet success",
  "Bet failed": "Bet failed",
  "Bet Slip": "Bet Slip",
  "My Bets": "My Bets",
  Parlay: "Parlay",
  Single: "Single",
  Matches: "Matches",
  "Max payout": "Max payout",
  Max: "Max",
  Min: "Min",
  More: "More",
  Bet: "Bet",
  VALIDATION_ERROR: "Validation error",
  RATE_LIMIT_REQUEST: "Reached your rate limit request",
  CANNOT_GET_PROFILE: "Cannot get your profile",
  ODDS_CHANGED: "Odds price has been changed",
  MATCH_NOT_FOUND: "Match not found",
  OVER_LITMIT_PER_MATCH: "Reached your rate limit per match",
  OVER_LITMIT_PER_BILL: "Reached your rate limit per bill",
  OVER_LITMIT_PER_DAY: "Reached your rate limit per day",
  ODDS_INVALID: "Invalid odds",
  DUPLICATE_BET: "Duplicated betting",
  INSUFFICIENT_BALANCE: "Your balance isn't enough",
  LOCKED_ACCOUNT: "Account is locked",
  SUSSPENDED_ACCOUNT: "Account is susspended",
  UNAVAILABLE_BET: "Betting is unavailable",
  TICKET_REJECTED: "Ticket was rejected",
  SYSTEM_ERROR: "Please try again later",
  INVALID_CURRENCY: "Invalid currency",
  INVALID_AMOUNT: "Invalid amount",
  SESSION_EXPIRED: "Session was expired",
  "Search Teams": "Search Teams or Leagues...",
  Over: "Over",
  Under: "Under",
  "share kickoff": "kickoff at",
  "share link": "Check prices at the link below",
  "share copied": "Link copied to clipboard",
  "share copy_failed": "Failed to copy link",
  "Minimum parlay matches": "Minimum {{count}} matches required",
  "Some matches unavailable": "Some matches are not available",
};

export default EN;
